import { jsx as _jsx } from "react/jsx-runtime";
import { CLOSE_ICON } from '@marvelapp/ballpark-theme';
import Button from './Button';
import Icon from './Icon';
export default function SearchCloseButton({ onClick, onMouseDown }) {
    return (_jsx(Button, { bg: "transparent", "data-testid": "search-close-button", height: 24, marginTop: -12, onClick: onClick, onMouseDown: onMouseDown, position: "absolute", px: 0, right: "6px", top: "50%", width: 24, children: _jsx(Icon, { "data-testid": "close-search-icon", paths: CLOSE_ICON }) }));
}
